import Vue from 'vue'
import App from './App.vue'
import Cookies from 'js-cookie'

// 引入 NutUI
import NutUI from '@nutui/nutui'

import router from './router'
import store from './store'

import i18n from './i18n' // 国际化

import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import ElementLocale from 'element-ui/lib/locale'
i18n.mergeLocaleMessage('en', { el: enLocale.el })
i18n.mergeLocaleMessage('zh', { el: zhLocale.el })

ElementLocale.i18n((key, value) => i18n.t(key, value))


import Element from 'element-ui'
import './styles/element-variables.scss'

import less from 'less'
import '@/styles/index.scss' // global css
import '@/styles/common.scss' // common css


import './icons' // icon
import './permission' // permission control
import directive from './directive' // directive
import plugins from './plugins' // plugins
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import { download } from '@/utils/request'
//自定义工具
import { parseTime,resetForm,addDateRange,handleTree } from "@/utils/tools";
import { checkPermi,checkRole } from "@/utils/permission";
// 分页组件
import Pagination from "@/components/Pagination";

// 字典标签组件
import DictTag from '@/components/DictTag'

// 字典数据组件
import DictData from '@/components/DictData'

Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

Vue.use(directive)
Vue.use(plugins)

Vue.use(Cookies)
Vue.use(less)
// 注册 NutUI
Vue.use(NutUI)

Vue.config.productionTip = false;

Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.download = download
Vue.prototype.handleTree = handleTree
Vue.prototype.checkPermi = checkPermi
// 全局组件挂载
Vue.component('Pagination', Pagination)
Vue.component('DictTag', DictTag)

DictData.install()

Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
